<template>
  <div>
    <ContentHeader :show-back="true" />
    <div class="content-container" v-loading="loading">
      <!-- 物料订单信息 -->
      <el-row class="form-item">
        <el-col class="title">{{ moduleTitle }}订单信息</el-col>
        <el-col>
          <el-table
            :data="stockList"
            class="order-data-table ie-table"
            ref="stockForm"
          >
            <el-table-column label="商品名称" prop="itemName" />
            <el-table-column label="商品编码" prop="itemCode" />
            <el-table-column
              v-if="pathType === 'quota'"
              label="配额名称"
              prop="quotaDTO.quotaName"
            />
            <el-table-column
              v-if="pathType === 'quota-cart'"
              label="配额名称"
              prop="quotaName"
            />
            <el-table-column
              v-if="moduleType === '04'"
              label="所属配额"
              prop="quotaName"
            />
            <el-table-column label="所在仓库" prop="warehouseName" />
            <el-table-column
              label="可用库存"
              prop="logicalStock"
              v-if="moduleType === '01'"
            />
            <el-table-column
              label="可用库存"
              prop="availableAmount"
              v-if="moduleType === '04'"
            />
            <!-- <el-table-column
              v-if="moduleType === '02'"
              label="全部配额"
              prop="totalQuota"
            /> -->
            <el-table-column
              v-if="moduleType === '02'"
              label="可用配额"
              prop="availableQuota"
            />
            <el-table-column
              v-if="moduleType === '03'"
              label="可用数量"
              prop="availableAmount"
            />
            <el-table-column label="区域编码" prop="orgCode" />
            <el-table-column label="品牌部门" prop="buTypeName" />
            <el-table-column label="单价" v-if="moduleType === '04'">
              <template slot-scope="scope">
                <span>￥{{ scope.row.itemPrice }}</span>
              </template>
            </el-table-column>
            <!-- 购物车下单不可选数量 -->
            <el-table-column
              v-if="orderType === 'many'"
              label="数量"
              prop="itemQuantity"
            />
            <!-- 立即下单可选数量 -->
            <el-table-column
              label="数量"
              min-width="120px"
              v-if="orderType === 'only'"
            >
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.itemQty"
                  size="mini"
                  :precision="0"
                  :min="1"
                  @change="getItemQty(scope.row)"
                ></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="小计" v-if="moduleType === '04'">
              <template slot-scope="scope">
                <span>￥{{ getItemAmount(scope.row) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              v-if="moduleType === '03'"
              label="单位"
              prop="itemUnit"
            />
            <el-table-column
              v-if="moduleType === '03'"
              prop="specParam"
              label="箱规"
            ></el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <el-row class="form-item form-input">
        <el-col class="title">填写信息</el-col>
        <el-row v-if="!onlySelf">
          <el-col :span="3" class="input-right">
            <p><span class="required-text">*</span>是否自提</p>
          </el-col>
          <el-col :span="8">
            <p class="delivery-radio">
              <span
                @click="stockForm.isSelfDelivery = 0"
                :class="!stockForm.isSelfDelivery ? 'activate-delivery' : ''"
                ><i></i>否</span
              >
              <span
                @click="stockForm.isSelfDelivery = 1"
                :class="stockForm.isSelfDelivery ? 'activate-delivery' : ''"
                ><i></i>是</span
              >
            </p>
          </el-col>
        </el-row>
        <el-row>
          <p v-if="moduleType === '01'">
            <el-col :span="3" class="input-right">
              <p><span class="required-text">*</span>出库单名称</p>
            </el-col>
            <el-col :span="5">
              <el-input
                v-model="stockForm.billName"
                placeholder="请输入出库单名称"
                clearable
                class="panel-input"
              />
            </el-col>
          </p>
          <el-col :span="3" class="input-right">
            <p><span class="required-text" v-if="requiredInput">*</span>申请人</p>
          </el-col>
          <el-col :span="5">
            <el-input
              v-model="stockForm.applyPerson"
              placeholder="请输入申请人名称"
              clearable
              class="panel-input"
            />
          </el-col>
          <el-col :span="3" class="input-right">
            <p><span class="required-text" v-if="requiredInput">*</span>渠道</p>
          </el-col>
          <el-col :span="5">
            <el-input
              v-model="stockForm.channelCode"
              placeholder="请输入渠道"
              clearable
              class="panel-input"
            />
          </el-col>
        </el-row>

        <el-row v-if="moduleType === '03'">
          <el-col :span="3" class="input-right">
            <p><span class="required-text" v-if="requiredInput">*</span>售点名称</p>
          </el-col>
          <el-col :span="5">
            <el-input
              v-model="stockForm.pocName"
              clearable
              placeholder="请输入售点名称"
              class="panel-input"
            />
          </el-col>

          <el-col :span="3" class="input-right">
            <p>售点年销量</p>
          </el-col>
          <el-col :span="5">
            <el-input
              v-model="stockForm.pocTotalSale"
              clearable
              placeholder="请输入售点年销量"
              class="panel-input"
            />
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="3" class="input-right">
            <p><span class="required-text" v-if="requiredInput">*</span>M1名称</p>
          </el-col>
          <el-col :span="5">
            <el-input
              v-model="stockForm.m1Name"
              clearable
              placeholder="请输入M1名称"
              class="panel-input"
            />
          </el-col>

          <el-col :span="3" class="input-right">
            <p><span class="required-text" v-if="requiredInput">*</span>M2名称</p>
          </el-col>
          <el-col :span="5">
            <el-input
              v-model="stockForm.m2Name"
              clearable
              placeholder="请输入M2名称"
              class="panel-input"
            />
          </el-col>

          <el-col :span="3" class="input-right">
            <p><span class="required-text" v-if="requiredInput">*</span>M3名称</p>
          </el-col>
          <el-col :span="5">
            <el-input
              v-model="stockForm.m3Name"
              clearable
              placeholder="请输入M3名称"
              class="panel-input"
            />
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3" class="input-right"><span class="required-text" v-if="requiredInput">*</span>用途信息</el-col>
          <el-col :span="21">
            <el-input
              type="textarea"
              rows="3"
              resize="none"
              v-model="stockForm.purposeInfo"
              :maxlength="150"
              placeholder="请输入用途信息"
            ></el-input>
          </el-col>
        </el-row>
      </el-row>

      <!-- 填写自提人信息 -->
      <el-row
        class="form-item template-form-item"
        v-if="stockForm.isSelfDelivery"
      >
        <el-col :span="3">
          <p><span class="required-text">*</span>自提人信息</p>
        </el-col>
        <el-col :span="21">
          <el-input
            type="textarea"
            rows="3"
            resize="none"
            v-model="stockForm.selfDeliveryInfo"
            :maxlength="150"
            placeholder="请输入自提人信息"
          ></el-input>
        </el-col>
      </el-row>

      <orderAddress v-if="!stockForm.isSelfDelivery" @setAddress="setAddress" />

      <div>
        <el-row class="form-item template-form-item">
          <el-col :span="3">订单备注</el-col>
          <el-col :span="21">
            <el-input
              type="textarea"
              rows="3"
              resize="none"
              v-model="remark"
              :maxlength="150"
              placeholder="请输入订单备注"
            ></el-input>
          </el-col>
        </el-row>
      </div>

      <el-row class="form-item order-price" v-if="moduleType === '04'">
        <el-col :span="10">订单明细</el-col>
        <el-col :span="5" class="price-row">
          <div>商品件数：{{ itemAmout }} 件</div>
          <div>
            商品合计 ￥ <span class="text-underline">{{ allAmount }}</span>
          </div>
        </el-col>
      </el-row>
      <div class="submit-btn">
        <el-button
          class="btn-red"
          :disabled="showSubmit ? false : true"
          @click="handleSubmit"
          >{{ showSubmit ? "+ 提交订单" : "订单处理中" }}</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '../../components/content-header'
import orderAddress from './components/order-address'
import { commonUtils } from '@/utils/common'
import { create, all } from 'mathjs/number'
import { mapState } from 'vuex'
const math = create(all)
export default {
  name: 'stock-fill-order',
  components: {
    ContentHeader,
    orderAddress
  },
  data () {
    return {
      loading: false,
      showSubmit: true,
      stockList: [],
      moduleTitle: '',
      itemAmout: 0,
      remark: '',
      clientAddressId: '',
      inventoryId: '',
      detailId: '',
      linkId: '',
      addressNum: 1,
      submitApiName: '',
      // quota：物资领用；quota-cart:物资购物车下单；stock:单个库存快速下单；stock-cart:库存购物车下单;
      // apply：物资申请；apply-cart：物资申请购物车下单;money:金额配额；money-cart:金额配额购物车下单
      pathType: '',
      moduleType: '', // 01库存，02配额，03物资申请，04金额配额
      orderType: 'only', // only:立即下单，many:购物车下单
      // 下单额外信息
      stockForm: {
        billName: '',
        isSelfDelivery: 0, // 0非自提，1自提
        selfDeliveryInfo: '',
        pocName: '',
        pocTotalSale: '',
        m1Name: '',
        m2Name: '',
        m3Name: '',
        applyPerson: '',
        channelCode: '',
        purposeInfo: ''
      },
      // 单个下单
      orderForm: {
        addressId: '',
        quotaId: '',
        itemId: '',
        itemQty: 1,
        warehouseId: '',
        remark: '',
        orgCode: '',
        buType: ''
      },
      // 多个库存下单
      cartOrderForm: {
        addressId: '',
        remark: '',
        cartIds: ''
      }
    }
  },
  computed: {
    ...mapState({
      stockSelfDeliveryBuTypeMap: state => state.base.stockSelfDeliveryBuTypeMap
    }),
    allAmount () {
      let total = 0
      if (this.stockList) {
        this.stockList.forEach(item => {
          total = total + item.getItemAmount
        })
      }
      return Number(commonUtils.formatNumber(total)).toFixed(2)
    },
    // 必填字段 物资申请以及领用必填
    requiredInput () {
      return Boolean(this.moduleType === '02' || this.moduleType === '03')
    },
    // buType自提列表
    selfDeliveryBuType () {
      let arrStr = this.stockSelfDeliveryBuTypeMap ? this.stockSelfDeliveryBuTypeMap[0].value : ''
      return arrStr ? arrStr.substring(1, arrStr.length - 1).split(', ') : []
    },

    // 物资领用 buType在自提列表内则仅能自提
    onlySelf () {
      let flag = false
      if (
        this.moduleType === '03' &&
        this.stockList.length &&
        this.selfDeliveryBuType.length
      ) {
        flag = this.stockList.some(item => {
          return this.selfDeliveryBuType.indexOf(item.buType) !== -1
        })
      }

      if (flag) {
        this.$set(this.stockForm, 'isSelfDelivery', 1)
      }
      return flag
    }
  },

  watch: {
    moduleType (val) {
      switch (val) {
        case '01':
          this.moduleTitle = '库存'
          break
        case '02':
          this.moduleTitle = '领用'
          break
        case '03':
          this.moduleTitle = '物资申请'
          break
        case '04':
          this.moduleTitle = '金额配额'
          break
      }
    }
  },
  created () {
    // quota：物资领用；quota-cart:物资购物车下单；stock:单个库存快速下单；stock-cart:库存购物车下单;
    // apply：物资申请；apply-cart：物资申请购物车下单;money:金额配额；money-cart:金额配额购物车下单
    this.pathType = this.$route.query.type
    this.init()
  },
  methods: {
    init () {
      this.$store.dispatch('getDictByName', 'stockSelfDeliveryBuTypeMap')
      switch (this.pathType) {
        case 'stock':
          this.inventoryId = this.$route.query.inventoryId
          this.moduleType = '01'
          this.orderType = 'only'
          this.submitApiName = 'stockOrder'
          this.getOnlyItmeList('queryStoct', this.inventoryId)
          break
        case 'stock-cart':
          this.moduleType = '01'
          this.orderType = 'many'
          this.submitApiName = 'stockCartOrder'
          this.getItemList()
          break
        case 'quota':
          this.detailId = this.$route.query.detailId
          this.moduleType = '02'
          this.orderType = 'only'
          this.submitApiName = 'quotaOrder'
          this.getOnlyItmeList('queryQuota', this.detailId)
          break
        case 'quota-cart':
          this.moduleType = '02'
          this.orderType = 'many'
          this.submitApiName = 'quotaCartOrder'
          this.getItemList()
          break
        case 'apply':
          this.linkId = this.$route.query.linkId
          this.moduleType = '03'
          this.orderType = 'only'
          this.submitApiName = 'getApplySubmit'
          this.getOnlyItmeList('queryApply', this.linkId)
          break
        case 'apply-cart':
          this.moduleType = '03'
          this.orderType = 'many'
          this.submitApiName = 'applyCartOrder'
          this.getItemList()
          break
        case 'money':
          this.linkId = this.$route.query.linkId
          this.moduleType = '04'
          this.orderType = 'only'
          this.submitApiName = 'getAmountSubmit'
          this.getOnlyItmeList('getAmountItemInfo', this.linkId)
          break
        case 'money-cart':
          this.moduleType = '04'
          this.orderType = 'many'
          this.submitApiName = 'amountCartOrder'
          this.getItemList()
      }
    },

    // 获取单个商品信息
    getOnlyItmeList (apiName, id) {
      this.loading = true
      this.$store
        .dispatch(apiName, id)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.stockList =
              res.data.resultData.stockInfo ||
              res.data.resultData.quotaInfo ||
              res.data.resultData.selectStockApplyItem ||
              res.data.resultData.stockAmountItem
            this.setOrderForm()
          }
        })
        .catch(() => {
          this.loading = false
        })
    },

    // 配置传参
    setOrderForm () {
      this.itemAmout = this.stockList.length
      this.orderForm.itemId = this.stockList[0].itemId
      this.orderForm.warehouseId = this.stockList[0].warehouseId
      this.orderForm.orgCode = this.stockList[0].orgCode
      this.orderForm.buType = this.stockList[0].buType
      this.orderForm.quotaId = this.stockList[0].quotaId
      if (this.stockList) {
        this.stockList.forEach((item, index) => {
          this.$set(item, 'itemQty', 1)
          this.$set(item, 'getItemAmount', 0)
        })
      }
    },

    // 获取多个出库商品信息
    getItemList () {
      let cartIds = []
      let params = {
        moduleType: this.moduleType
      }
      this.loading = true
      this.$store
        .dispatch('queryStockCartSettlement', params)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.stockList = res.data.resultData.stockShoppingCartList
            this.itemAmout = this.stockList.length
            if (this.stockList) {
              this.stockList.forEach(item => {
                cartIds.push(item.cartId)
                this.$set(item, 'getItemAmount', 0)
              })
            }
            this.cartOrderForm.cartIds = cartIds.join(',')
          }
        })
        .catch(() => {
          this.loading = false
        })
    },

    // 金额配额类型 商品价格小计
    getItemAmount (row) {
      let price = 0
      let qty = row.itemQty || row.itemQuantity
      if (qty && row.itemPrice) {
        price = commonUtils.formatNumber(math.multiply(qty, row.itemPrice))
      }
      row.getItemAmount = price
      return price
    },

    // 下单验证
    checkSubmit () {
      if (!this.stockForm.billName && this.moduleType === '01') {
        this.$message.error('请填写出库单名称')
        return false
      }
      if (this.requiredInput) {
        if (!this.stockForm.applyPerson) {
          this.$message.error('请输入申请人名称')
          return false
        }
        if (!this.stockForm.channelCode) {
          this.$message.error('请输入渠道')
          return false
        }
        if (!this.stockForm.pocName && this.moduleType === '03') {
          this.$message.error('请输入售点名称')
          return false
        }
        if (!this.stockForm.m1Name) {
          this.$message.error('请输入M1名称')
          return false
        }
        if (!this.stockForm.m2Name) {
          this.$message.error('请输入M2名称')
          return false
        }
        if (!this.stockForm.m3Name) {
          this.$message.error('请输入M3名称')
          return false
        }
        if (!this.stockForm.purposeInfo) {
          this.$message.error('请输入用途信息')
          return false
        }
      }
      if (!this.stockForm.selfDeliveryInfo && this.stockForm.isSelfDelivery) {
        this.$message.error('请填写自提人信息')
        return false
      }
      if (!this.clientAddressId && !this.stockForm.isSelfDelivery) {
        this.$message.error('请选择收货地址')
        return false
      }

      if (!this.orderForm.itemQty && this.orderType === 'only') {
        this.$message.error('数量为空，请添加数量')
        return false
      }

      return true
    },

    // 匹配提交的接口
    getApi () {
      let params =
        this.orderType === 'many'
          ? Object.assign({}, this.stockForm, this.cartOrderForm)
          : Object.assign({}, this.stockForm, this.orderForm)

      // 处理多余数据
      if (this.pathType === 'apply') {
        delete params.quotaId
      } else if (this.pathType === 'apply-cart') {
        delete params.cartIds
      }
      if (this.moduleType !== '01') {
        delete params.billName
      }
      if (this.stockForm.isSelfDelivery) {
        params.addressId = ''
      } else {
        params.selfDeliveryInfo = ''
      }

      params.remark = this.remark
      return { params: params }
    },

    // 提交订单
    handleSubmit () {
      if (!this.checkSubmit()) {
        return
      }
      this.showSubmit = false
      this.loading = true
      this.$store
        .dispatch(this.submitApiName, this.getApi().params)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            let successNumber =
              res.data.resultData.billNumber ||
              res.data.resultData.orderNumber ||
              res.data.resultData.applyNumber
            this.$router.push({
              path: '/stock/stock-order-success',
              query: {
                moduleType: this.moduleType,
                successNumber: successNumber
              }
            })
          }
          this.showSubmit = true
        })
        .catch(() => {
          this.loading = false
          this.$message.error('订单提交失败')
          this.showSubmit = true
        })
    },
    // 获取地址
    setAddress (val) {
      this.clientAddressId = val.clientAddressId || ''
      this.orderForm.addressId = this.clientAddressId || ''
      this.cartOrderForm.addressId = this.clientAddressId || ''
    },
    getItemQty (row) {
      if (!row.itemQty) {
        this.$message.error('数量为空，请重新操作')
      }
      this.orderForm.itemQty = row.itemQty
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item {
  padding: $content-large;
}
.form-input {
  .el-row {
    margin: 15px 0;
    .input-right {
      text-align: right;
      padding-right: 20px;
    }
    .el-select {
      width: 100%;
    }
  }
}
.delivery-radio {
  span {
    cursor: pointer;
    margin-right: 30px;
    padding: 5px;
    i {
      height: 10px;
      width: 10px;
      border: 1px solid #ccc;
      border-radius: 50%;
      display: inline-block;
      margin-right: 10px;
    }
  }
  .activate-delivery {
    font-weight: 600;
    color: rgb(200, 16, 45);
    i {
      border-color: rgb(200, 16, 45);
      background: rgb(200, 16, 45);
    }
  }
}
.order-price {
  background-color: #ffd6e8;
  padding: $content-large;
  // height: 80px;
  .price-row {
    div {
      margin-bottom: 10px;
      .text-red {
        font-weight: bold;
        color: $base-red;
        font-size: 16px;
      }
    }
  }
}

.submit-btn {
  margin-top: $content-large;
  text-align: center;
}
</style>
